/**
 * Alineado con `src/styles/tokens/_effects.scss` ($motion-press-*, $transition-press-transform).
 * Usar en `whileTap` de Framer Motion donde el CSS global no basta o hay que evitar choque con layout.
 */
export const MOTION_PRESS_DURATION_MS = 220;

export const motionPressWhileTap = {
  scale: 0.85,
  transition: { duration: MOTION_PRESS_DURATION_MS / 1000, ease: 'easeInOut' as const },
};
